import { Component, Input } from "@angular/core";

@Component({
  selector: "ads-card",
  templateUrl: "./card.component.html",
})
export class CardComponent {
  @Input("class") class: string = "";
  @Input("showHeader") showHeader: boolean = true;
  @Input("showFooter") showFooter: boolean = true;
  @Input("headerCSSClass") headerCSSClass: string = "";
  @Input("bodyCSSClass") bodyCSSClass: string = "";
  @Input("footerCSSClass") footerCSSClass: string = "";
  @Input("cardStyles") cardStyles: string = "";
  @Input("headerStyles") headerStyles: string = "";
  @Input("bodyStyles") bodyStyles: string = "";
  @Input("footerStyles") footerStyles: string = "";
  constructor() { }
}
